import {Component, Input} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import {SetIsClaimTestDataService} from "./set-is-claim-test-data.service";

@Component({
  selector: 'app-is-claim-test-data',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './is-claim-test-data.component.html',
  styleUrl: './is-claim-test-data.component.scss'
})
export class IsClaimTestDataComponent {
  @Input() public ClaimDto!: ClaimDto;

  constructor(private setIsClaimTestDataService: SetIsClaimTestDataService) {
  }

  setIsClaimTestData() {
    this.setIsClaimTestDataService.setIsClaimTestData(this.ClaimDto.claimId, this.ClaimDto.isClaimTestData).subscribe(() => {
    });
  }
}
